<template>
  <div class="chatWindowVue">
    <chat-panel mode="window"></chat-panel>
    <div v-if="!enabled" class="cw__off">
      Chat preview is not enabled in this build.
    </div>
  </div>
</template>

<script>
/**
 * #2091 r4 — the undocked chat, as its own page.
 *
 * Deliberately thin: it renders `chatPanel` in `window` mode rather than
 * reimplementing the chat. The channel list, the job windows, the office-hours
 * rules, the composer and the 120-message scrollback are the same chat whether
 * it is docked or on a second monitor, and a second copy would drift from the
 * first the moment either changed.
 *
 * Behind the same flag as the panel: with CHAT_UI_PREVIEW off this route renders
 * a single line saying so, rather than a blank window that looks broken.
 *
 * ⚠ This window is a SEPARATE JS context, so it has its own copy of the preview
 * settings — switching a group off here does not change the other window. For a
 * preview with no back end that is the honest behaviour; real shared state
 * arrives with the service (#6-#10, #18).
 */
import chatPanel from './chatPanel.vue';
import { chatUiEnabled } from '../../chatPreview.js';

export default {
    name: 'chatWindow',
    components: { chatPanel },
    computed: {
        enabled() { return chatUiEnabled(); },
    },
    mounted() {
        document.title = 'CallSteward Chat';
    },
};
</script>

<style scoped>
.chatWindowVue{height:100vh;overflow:hidden;background:#fff}
.cw__off{padding:24px;font-size:13px;color:#6b7280}
</style>
